<div class="puppet__section usa-order">
  <h6 class="puppet__section-title">Realizar orden</h6>

  <div class="field">
    <label for="amount"
      >Monto
      {{
        operation === capitalOperations.buy
          ? 'a partir de $' + minimumToOperate
          : ''
      }}</label
    >
    <div
      class="puppet__toggle-amount toggle-radio__group usa-order__price-buttons"
    >
      <div
        class="toggle-radio__input"
        *ngFor="let groupValue of amountGroupValues"
      >
        <input
          type="radio"
          id="puppet-toggle-value-{{ groupValue.value }}"
          name="puppet-toggle-value-{{ groupValue.value }}"
          [disabled]="disableForm"
          [value]="groupValue.value"
          [(ngModel)]="amountToOperate"
        />
        <label for="puppet-toggle-value-{{ groupValue.value }}">{{
          groupValue.label
            ? groupValue.label
            : (groupValue.value | currency: 'MXN':'symbol-narrow':'1.0-0')
        }}</label>
      </div>
    </div>

    <hb-input-money
      class="usa-order__amount-input"
      placeholder="$0"
      prefix="$"
      [(value)]="amountToOperate"
      [disabled]="disableForm"
      [isError]="
        operation === capitalOperations.buy
          ? amountToOperate < minimumToOperate ||
            amountToOperate > availableToBuy
          : amountToOperate > availableToSell
      "
    >
      <ng-container
        *ngIf="
          operation === capitalOperations.buy &&
          amountToOperate < minimumToOperate &&
          amountToOperate <= availableToBuy
        "
      >
        El monto mínimo de {{ actionCopies.noun[operation] }} es de ${{
          minimumToOperate
        }}
      </ng-container>
      <ng-container
        *ngIf="
          operation === capitalOperations.buy
            ? amountToOperate > availableToBuy
            : amountToOperate > availableToSell
        "
      >
        No cuentas con suficiente disponible para
        {{ actionCopies.verb[operation] }}
      </ng-container>
    </hb-input-money>
  </div>

  <p class="puppet__simple-message">
    Títulos aproximados:
    <strong>
      {{ amountToOperate / unitPrice || 0 | mask: 'separator.8':',' }}</strong
    >
  </p>

  <p class="puppet__simple-message">
    Disponible para {{ actionCopies.verb[operation] }}:
    <strong
      class="puppet__simple-message--secure-amount"
      data-recording-sensitive
      (click)="handleBuyingPowerSecureAmount()"
      *ngIf="operation === capitalOperations.buy"
    >
      ${{ availableToBuy | mask: 'separator.2':',' }}</strong
    >
    <strong
      data-recording-sensitive
      *ngIf="operation === capitalOperations.sell"
    >
      ${{ availableToSell | mask: 'separator.2':',' }}</strong
    >
  </p>

  <div
    class="usa-order__out-of-service information-card"
    *ngIf="
      !isOutOfOperationTime &&
      issueOperationStatus &&
      issueOperationStatus !== marketStatus.active
    "
  >
    <div class="information-card__container">
      <div
        class="information-card__leading-icon information-card__leading-icon--info"
      ></div>
      <div class="information-card__information">
        <ng-container *ngIf="issueOperationStatus === marketStatus.closeOnly">
          <!-- --------------------- With holdings of that title --------------------- -->
          <p *ngIf="!availableToSell">
            Por el momento, no se pueden realizar compras de esta emisora
          </p>
          <!-- ------------------- Without holdings of that title -------------------- -->
          <p *ngIf="availableToSell">
            Por el momento, sólo se pueden realizar ventas de esta emisora
          </p>
        </ng-container>
        <p
          *ngIf="
            issueOperationStatus === marketStatus.halted ||
            issueOperationStatus === marketStatus.inactive
          "
        >
          Por el momento, no se pueden generar órdenes de esta emisora
        </p>
      </div>
    </div>
  </div>

  <div
    class="usa-order__out-of-service information-card"
    *ngIf="show3DayTrade && !showMaxDayTradesMessage && !showThirdVirtualDt"
  >
    <div class="information-card__container">
      <div
        class="information-card__leading-icon information-card__leading-icon--info"
      ></div>
      <div class="information-card__information">
        <p>
          Esta {{ actionCopies.noun[operation] }} puede generar un tercer day
          trade
          <button
            class="button button--link button--semibold button--link-hover"
            type="button"
            (mouseenter)="showTooltip = true"
            (mouseleave)="showTooltip = false"
          >
            Conocer más
            <hb-tooltip-component
              *ngIf="showTooltip"
              [text]="DAY_TRADE_INFO"
              relativePosition="top"
              width="288"
              theme="dark"
              [hideTip]="true"
              [hideShadow]="true"
              (onClose)="showTooltip = false"
            >
            </hb-tooltip-component>
          </button>
        </p>
      </div>
    </div>
  </div>

  <div
    class="usa-order__out-of-service information-card"
    *ngIf="showMaxDayTradesMessage"
  >
    <div class="information-card__container">
      <div
        class="information-card__leading-icon information-card__leading-icon--info"
      ></div>
      <div class="information-card__information">
        <p>
          Alcanzaste el límite de day trades. Podrás realizar
          {{ actionCopies.plural[operation] }} de esta emisora a partir del
          {{ nextDateLabel }}.
          <button
            class="button button--link button--semibold button--link-hover"
            type="button"
            (click)="handleOpenDayTradeInfo()"
          >
            Conocer más
          </button>
        </p>
      </div>
    </div>
  </div>

  <div
    class="usa-order__out-of-service information-card"
    *ngIf="showLiquidateOnlyMessage"
  >
    <div class="information-card__container">
      <div
        class="information-card__leading-icon information-card__leading-icon--info"
      ></div>
      <div class="information-card__information">
        <p>
          La identificación de tu contrato no está vigente, actualízala para
          seguir comprando acciones
          <button
            class="button button--link button--semibold button--link-hover"
            type="button"
            (click)="handleToggleModal()"
          >
            ¿Cómo la actualizo?
          </button>
        </p>
      </div>
    </div>
  </div>

  <div
    class="usa-order__out-of-service information-card"
    *ngIf="showThirdVirtualDt"
  >
    <div class="information-card__container">
      <div
        class="information-card__leading-icon information-card__leading-icon--info"
      ></div>
      <div class="information-card__information">
        <p>
          Solo podrás generar {{ actionCopies.pluralVersus[operation] }} de esta
          emisora.
          <button
            class="button button--link button--semibold button--link-hover"
            type="button"
            (mouseenter)="showTooltip = true"
            (mouseleave)="showTooltip = false"
          >
            Conocer más
            <hb-tooltip-component
              *ngIf="showTooltip"
              [text]="VIRTUAL_DAY_TRADE_INFO"
              relativePosition="top"
              width="288"
              theme="dark"
              [hideTip]="true"
              [hideShadow]="true"
              (onClose)="showTooltip = false"
            >
            </hb-tooltip-component>
          </button>
        </p>
      </div>
    </div>
  </div>

  <!-- double selling disclaimer -->
  <div
    *ngIf="showDoubleSellMessage && isOutOfOperationTime"
    class="usa-order__out-of-service information-card"
  >
    <div class="information-card__container">
      <div
        class="information-card__leading-icon information-card__leading-icon--info"
      ></div>
      <div class="information-card__information">
        <p>
          Tienes una venta de esta emisora en proceso, puedes cancelarla si
          deseas efectuar una nueva venta.
          <button
            class="button button--link button--semibold button--link-hover"
            type="button"
            (click)="handleOpenDoubleSellingModal()"
          >
            Conocer más
          </button>
        </p>
      </div>
    </div>
  </div>

  <button
    class="button button--dark puppet__footer-button"
    (click)="handleOperateClick()"
    [ngClass]="{
      'button--disabled':
        disableForm ||
        !amountToOperate ||
        (operation === capitalOperations.buy &&
          (amountToOperate < minimumToOperate ||
            amountToOperate > availableToBuy)) ||
        (operation === capitalOperations.sell &&
          amountToOperate > availableToSell) ||
        !enableTradingUsaOperation ||
        (showDoubleSellMessage && isOutOfOperationTime)
    }"
  >
    Continuar
  </button>

  <app-confirmation-modal
    *ngIf="showConfirmation"
    [order]="confirmationOrder"
    [fractionalTitles]="true"
    [isOutOfTime]="isOutOfOperationTime"
    (onClose)="cancelConfirmation()"
    (confirmationHandler)="registerOrder()"
  >
  </app-confirmation-modal>
</div>

<!-- double selling side modal -->
<app-side-modal
  #doubleSellingModal
  (goBack)="handleCloseDoubleSellingModal()"
  class="day-trade--details"
>
  <hb-double-selling
    [order]="prevPendingOrder"
    (closeSideModal)="handleCloseDoubleSellingModal(true)"
  ></hb-double-selling>
</app-side-modal>

<!-- daytrades side modal -->
<app-side-modal
  #sideModal
  (goBack)="handleCloseDayTradeInfo()"
  class="day-trade--details"
>
  <hb-day-trades-info *ngIf="showDayTradesInfo"></hb-day-trades-info>
  <hb-buying-power-secure-amount
    *ngIf="showBpSecureAmount"
  ></hb-buying-power-secure-amount>
</app-side-modal>
<app-full-modal
  *ngIf="showModalLiquidateOnly"
  [hideActionButtons]="true"
  (onCloseModal)="handleToggleModal()"
>
  <div class="modal-liquidation-container">
    <div class="modal-liquidation-container__title">
      Revisa tu correo electrónico
    </div>
    <div class="modal-liquidation-container__description">
      Te enviamos las instrucciones para actualizar tu identificación. Responde
      a nuestro correo con tu documento vigente adjunto y podrás seguir
      comprando acciones en Trading USA
      <div class="modal-liquidation-container__description--ask">
        ¿Tienes alguna duda? Contáctanos
      </div>
    </div>

    <div class="modal-liquidation-detail">
      <div class="modal-liquidation-detail__icon">
        <hb-icon
          category="Communication"
          name="PhoneCall"
          [size]="20"
        ></hb-icon>
      </div>
      <div class="modal-liquidation-detail__phone">
        INT. 800 426 4663<span>\</span>CDMX. 55 5480 5846
      </div>
    </div>
    <div class="modal-liquidation-detail">
      <div class="modal-liquidation-detail__mail-icon">
        <hb-icon category="Communication" name="Mail" [size]="20"></hb-icon>
      </div>
      <div class="modal-liquidation-detail__mail">plus@gbm.com</div>
    </div>
    <div class="modal-liquidation-detail__action">
      <button
        type="button"
        (click)="handleToggleModal()"
        class="button button--big button--dark"
      >
        Entendido
      </button>
    </div>
  </div>
</app-full-modal>
